/** @format */

import React from "react";

const UnauthorizedPage = () => {
  return <h1>Forbidden Error.</h1>;
};

export default UnauthorizedPage;
